export enum FeatureFlag {
	EnabledRefactoredMFA = 'enable_refactored_mfa',
}
